import React from 'react';
import BondsSearchBar from './BondsSearchBar';
import { Modal } from '@ui/atoms';
import BondResultsMobile from './BondResultsMobile';
import { buttonSizes } from '@ui/atoms/utils/enums';
import Button from '@ui/atoms/design-system/Button';
import { useBondDirectoryContext } from '../context/bond-directory-context';

const BondSearchModal = () => {
    const { onClose, showSearchModal, loading, value } =
        useBondDirectoryContext(({ states, callbacks }) => ({
            onClose: callbacks.onCloseSearchModal,
            showSearchModal: states.showSearchModal,
            loading: states.loading.searchButton,
            value: states.searchQuery,
        }));
    return (
        <Modal
            show={showSearchModal}
            onClose={onClose}
            mainWrapperClassName="!w-screen !h-[100svh] !p-0"
            width="w-full h-full !rounded-none !m-0"
            hideTitle
            height={'!overflow-y-hidden bg-primary-800'}
            paddingClass="p-0 h-full flex flex-col"
        >
            <div className="sticky px-4 py-3 shadow-md top-16 bg-basicWhite">
                <BondsSearchBar isSearchIcon={false} id="bondSearchMobile" />
            </div>
            <BondResultsMobile />
            <div
                className="sticky bottom-0 px-4 py-3 bg-basicWhite "
                style={{
                    boxShadow: ' 0px -4px 14px 0px rgba(11, 7, 110, 0.10)',
                }}
            >
                <Button
                    buttonText={'Search'}
                    buttonSize={buttonSizes.EXTRA_SMALL}
                    type="submit"
                    widthClass="w-full min-w-fit max-w-[420px] mx-auto"
                    disabled={loading || !value}
                />
            </div>
        </Modal>
    );
};

export default BondSearchModal;
